import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { UtensilsCrossedIcon, HotelIcon, ConciergeBellIcon, ShoppingBagIcon, FactoryIcon, NetworkIcon, Building2Icon, HeartHandshakeIcon, LandmarkIcon } from 'lucide-react';
import { Header } from '../components/Header';
import { CTASection } from '../components/CTASection';
import { DemoModal } from '../components/DemoModal';
import { Footer } from '../components/Footer';
import { PageHero } from '../components/PageHero';
import { industries } from '../data/industries';
const iconMap = {
  utensils: UtensilsCrossedIcon,
  hotel: HotelIcon,
  concierge: ConciergeBellIcon,
  shopping: ShoppingBagIcon,
  factory: FactoryIcon,
  network: NetworkIcon,
  building: Building2Icon,
  heart: HeartHandshakeIcon,
  landmark: LandmarkIcon
};
export function IndustriesPage() {
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
  return <motion.main initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.4
  }} className="min-h-screen w-full bg-stark-white overflow-x-hidden" data-id="element-284" data-mp="1jn8wrjodygxa">
      <Header onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-285" data-mp="1vgddv2oeqtd5" />

      <PageHero eyebrow="Industries" title="Built for hospitality and service businesses of every size." description="From a single location to a national footprint, ROI Complete adapts to the operating reality of your industry." data-id="element-286" data-mp="1ho5mxrjt1wmd" />

      <section className="pt-16" data-id="element-287" data-mp="2ecv39dfsah68">
        <div className="max-w-7xl mx-auto px-6" data-id="element-288" data-mp="2ebtszb6ldypk">
          <motion.img initial={{
          opacity: 0,
          scale: 0.98
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} src="https://cdn.magicpatterns.com/patterns/generated-images/8701364f-d841-4135-80f5-bc4877805d3e.jpg" alt="Hotel lobby, professional kitchen and retail counter representing the industries ROI Complete serves" className="w-full h-auto rounded-2xl shadow-2xl shadow-midnight-navy/10" data-id="element-289" data-mp="20dc9xqrmtadz" />
        </div>
      </section>

      <section className="py-24 md:py-32" data-id="element-290" data-mp="3s9691jawow02">
        <div className="max-w-7xl mx-auto px-6" data-id="element-291" data-mp="3s83l9k8vr9od">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-292" data-mp="3s7bv4oy1y45h">
            {industries.map((industry, idx) => {
            const Icon = iconMap[industry.icon as keyof typeof iconMap];
            return <motion.article key={industry.name} initial={{
              opacity: 0,
              y: 24
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: idx * 0.05,
              ease: 'easeOut'
            }} whileHover={{
              y: -6
            }} className="group p-8 bg-stark-white border border-midnight-navy/10 rounded-2xl hover:border-royal-blue/40 hover:shadow-xl hover:shadow-midnight-navy/5 transition-all" data-id="element-293" data-mp="3e8lp2jt98u4z" data-mpi={idx}>
                  <div className="w-12 h-12 rounded-2xl bg-cool-gray text-royal-blue flex items-center justify-center mb-8 group-hover:bg-royal-blue group-hover:text-stark-white transition-colors" data-id="element-294" data-mp="w4vxoucvndi9">
                    <Icon className="w-6 h-6" data-id="element-295" data-mp="160z1e4ndnk7b" />
                  </div>
                  <h2 className="text-midnight-navy text-xl font-montserrat font-bold mb-3" data-id="element-296" data-mp="1a3vdrdmbqk2t">
                    {industry.name}
                  </h2>
                  <p className="text-midnight-navy/50 leading-relaxed" data-id="element-297" data-mp="2hgnjoiporv1s">
                    {industry.description}
                  </p>
                </motion.article>;
          })}
          </div>
        </div>
      </section>

      <CTASection onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-298" data-mp="2f2s8ggjzw6c5" />
      <Footer data-id="element-299" data-mp="2f4d5ccts81d6" />
      <DemoModal isOpen={isDemoModalOpen} onClose={() => setIsDemoModalOpen(false)} data-id="element-300" data-mp="2tzj90t5eno3c" />
    </motion.main>;
}